<lib-simple-list [configService]="carLinerIncludedItemsByIdsService"></lib-simple-list>
